module.exports = function() {
	return new Worker(__webpack_public_path__ + "cd682fd5791c0fd943fb.crops.js");
};